import { join } from "ramda";
import queryString from "query-string";

import externalLinks from "../constants/externalLinks";

const getUpsellRedirectUrl = (referrer) =>
  join("", [
    externalLinks.premium,
    "?",
    queryString.stringify({
      referrer,
      return_url: window.location.href,
    }),
    "#plans",
  ]);

export { getUpsellRedirectUrl };
